import LabelCheckbox from './LabelCheckbox';

export default LabelCheckbox;
